<template>
  <div class="flex flex-col justify-between text-center font-sans-serif">
    <div class="w-full relative flex items-center justify-end py-6 text-lg mb-8
    bg-orange-academy-300 text-white">
      <div class="w-full text-center absolute
      font-bold tracking-widest uppercase" v-if="selectedSlot.teacher">
        {{ $t('lesson.lessonWith') }}
          <button class="font-black uppercase" @click="loadDashboard(selectedSlot.teacher, true)">
            {{ selectedSlot.teacher.name }}
          </button>
      </div>
      <button @click.prevent="$modal.hide('student-lesson')" class="px-4 z-20">
        <close-icon />
      </button>
    </div>
    <div class="md:w-3/4 w-5/6 mx-auto flex flex-col justify-between text-lg mb-8">
      <div class="mb-2">
        <strong>
          {{ selectedEvent && selectedEvent.start.format('DD/MM/YYYY') }}</strong>
      </div>
      <div class="mb-2">
        {{$t('bookingSlots.from')}}  <strong class="mr-4">
          {{ selectedEvent && selectedEvent.start.formatTime() }}</strong>
        {{$t('bookingSlots.to')}} <strong>
          {{ selectedEvent && selectedEvent.end.formatTime() }}</strong>
      </div>
      <div class="py-8" v-if="showStartButton(selectedSlot.lesson)">
        <button
          @click="startLesson"
          class="md:px-6 px-5 py-3 rounded border bg-orange-academy-300 border-orange-academy-300
          uppercase hover:bg-white text-white hover:text-orange-academy-300 font-bold">
            {{ $t('lesson.goClassrooms') }}
        </button>
      </div>
      <div class="flex flex-col mt-6" v-if="isLocked">
        <span class="mb-4">{{ $t('bookingSlots.uncompleted') }}</span>
        <button @click="completeBooking"
          class="md:px-6 px-5 py-3 rounded border bg-orange-academy-300 border-orange-academy-300
          uppercase hover:bg-white text-white hover:text-orange-academy-300 font-bold">
            {{ $t('bookingSlots.complete') }}
        </button>
        <span class="text-sm mt-1">
          {{ $t('bookingSlots.inAnHour') }}
        </span>
     </div>
      <!--<div class="flex flex-row justify-between items-center mt-6 text-sm">
        <h2 class="text-black text-center
          font-bold tracking-widest uppercase py-2 text-md">
          Need to change the lesson?
        </h2>
        <button v-if="selectedSlot.teacher"
          @click="$emit('change')"
          class="md:px-6 px-5 py-3 rounded border bg-orange-academy-300 border-orange-academy-300
          uppercase hover:bg-white text-white hover:text-orange-academy-300
          font-bold cursor-pointer">
            Notify {{selectedSlot.teacher.firstname}}
        </button>
      </div> -->
    </div>
  </div>
</template>

<script>
import LessonMixin from '@/mixins/LessonMixin';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import CloseIcon from '@/components/graphics/CloseIcon.vue';

export default {
  props: ['selectedEvent', 'selectedSlot', 'isLocked'],

  mixins: [LessonMixin, StreamFunctionsMixin],

  components: {
    CloseIcon,
  },

  methods: {
    startLesson() {
      this.$router.push('/student-dashboard/classrooms');
    },

    completeBooking() {
      this.$router.push({
        path: `/teachers/${this.selectedSlot.teacher.slug}/calendar?booking=${this.selectedEvent.booking_id}`,
      });
    },
  },
};
</script>
